// ** React Imports
import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import NavbarUser from "./NavbarUser";
import themeConfig from "@configs/themeConfig";
import useUser from "../../../../utility/context/useUserContext";

const ThemeNavbar = (props) => {
  // ** Props
  const { skin, setSkin } = props;
  const { user } = useUser();

  return (
    <Fragment>
      <div className="bookmark-wrapper d-flex align-items-center gap-3">
        <img
          src={user?.broker?.logo}
          style={{ objectFit: "contain" }}
          width={170}
          height={50}
        />
        <NavLink to={"/home"} className="navbar-brand">
          <h2 className="brand-text mb-0" style={{ color: "#6767AB" }}>
            <span style={{ color: "#4b4b4b" }}>
              <small>Powered by </small>
            </span>
            <strong>
              {themeConfig.app.appNameFirst}
              <span style={{ color: "#4b4b4b" }}>
                {themeConfig.app.appNameLast}
              </span>
            </strong>
          </h2>
        </NavLink>
      </div>
      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  );
};

export default ThemeNavbar;
